import React from "react";
import Category from "../products/category";

function Home() {
  return <div className=" md:h-[69.6vh]  lg:px-[200px] md:px-[2%] px-[4%] overflow-y-auto">
    <Category />
  </div>;
}

export default Home;
